<template>
  <Card
    class="card"
    :hasHeaderDivider="true"
  >
    <template v-slot:header>
      <HeadingMedium>
        Folder Sharing
      </HeadingMedium>
      <ParagraphBody>
        Set which users and groups can create shared folders.
      </ParagraphBody>
    </template>
    <template v-slot:body>
      <RadioGroup
        label=""
        name="sharedFoldersRadioGroup"
        :options="$options.radioOptions"
      />
    </template>
  </Card>
</template>

<script>
import {
  Card,
  HeadingMedium,
  ParagraphBody,
  RadioGroup,
} from '@jumpcloud/ui-components';

const radioOptions = [{
  label: 'All users can create shared folders',
  value: 'allUsers',
},
{
  label: 'Specify which users and groups can create shared folders',
  value: 'specified',
}];

export default {
  name: 'SharedFoldersSettingsCard',

  components: {
    Card,
    HeadingMedium,
    ParagraphBody,
    RadioGroup,
  },

  radioOptions,
};
</script>

  <style scoped>
  .card {
    flex-basis: 60%;
  }

  .innerCard {
    padding-top: 0 !important;
  }

  .dividerLine {
    background-color: var(--jc-color-disabled-stroke);
    height: 1px;
    margin: var(--jc-spacer) 0 var(--jc-spacer);
    width: 100%;
  }
  </style>
